module.exports = __webpack_public_path__ + "static/media/back.f6998ff6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MobileApp/back.svg
// module id = 986
// module chunks = 0